/** URL para abrir o drawer de protocolo na listagem pós-venda. */
export function buildPosVendaProtocoloUrl(
  protocolId: string,
  options?: { clientId?: string | null }
): string {
  const params = new URLSearchParams({ protocoloId: protocolId });
  const clientId = options?.clientId?.trim();
  if (clientId) params.set('clientId', clientId);
  return `/pos-venda?${params.toString()}`;
}
